export default __webpack_public_path__ + "static/media/message-sending.997ea569.svg";